import {React, useContext} from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Toolbar, IconButton, Typography, useMediaQuery} from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import { SiteContext } from '../utils/SiteContext';

/** Local styled components */
const AppBarRoot = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerWidth',
})(({ theme, open, drawerWidth }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Logo = styled('img')(({ theme }) => ({
  margin: 10,
  height: 40,
}));

export default function AppHeader({open, drawerWidth, onToggleDrawer}) {
    const {userInfo, tab, custCompany} = useContext(SiteContext);
    const [userInfoVal,] = userInfo;
    const [custCompanyVal,] = custCompany;

    const isMobile = useMediaQuery("(max-width: 600px)");

    return (
        <AppBarRoot
        open={open}
        drawerWidth={drawerWidth}
        sx={{
            bgcolor: 'white',
            boxShadow: 'none',
            flexDirection: 'row',
            alignItems: 'center',
            height: '65px',
        }}
        >
        {/* Menu button shown only when Drawer is closed */}
            <Toolbar sx={{ ...(open && { display: 'none' }) }}>
                <IconButton
                color="black"
                aria-label="open drawer"
                onClick={onToggleDrawer}
                edge="start"
                >
                <MenuIcon />
                </IconButton>
            </Toolbar>

            {/* Content row */}
            {isMobile ?(
              
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', marginRight: 2 }}>
                <Logo src={'WCA-HeaderLogo.png'} alt={'WCA logo'} />
              </Box>

            ) : (
              <Box
                  sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  ...(open && { marginLeft: '10px' }),
                  }}
              >
                  {/* Left section: site logo + title */}
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Logo src={'WCA-HeaderLogo.png'} alt={'WCA logo'} />
                  <Typography variant="subtitle1" sx={{ color: 'maroon', fontWeight: 'bold' }}>
                      Whalley Computer Associates Portal
                  </Typography>
                  </Box>

                  {/* Right section: welcome + company logo */}
                  <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
                  <Typography variant="body1" sx={{ color: 'black', marginLeft: 2 }}>
                      Welcome, {userInfoVal.name}
                  </Typography>
                  <Logo src={custCompanyVal ? custCompanyVal.logo : "Blank.png"} alt={'Logo'} />
                  </Box>
              </Box>

            )}
        </AppBarRoot>
    );
}




